import React, { Component } from 'react';
import axios from 'axios';
import { config } from '../../Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../Asset/Css/Site.css';
import Select from 'react-select';
import global from '../global';
import 'react-notifications-component/dist/theme.css'
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import goBack from '../../Asset/Images/previous-icon.png';
import EasyDebenturesLogo from '../../Asset/Images/easy-dividend-logo.png';

export class Offlineform15GH extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TypeOfBeneficiary: [],
            BeneficiaryName: ''
        };

        this.initialState = this.state;

        localStorage.clear(); //for localStorage
        sessionStorage.clear(); //for sessionStorage
    }

    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    handelDownloadTemplate () {
        axios.get(global.OfflineResident.DownloadTemplateAPI)
            .then(response => {
                if (response.data.status) {
                    console.log("Success");                    
                }
                else {

                }
            })
            .catch(error => {
                this.setState({ loading: false });
            });
    }

    render() {

        return (
            <div>
                <ReactNotification />
                <div className="limiter">
                    <div className="container-login100" style={{ backgroundImage: 'url("' + mainBG + '")' }}>
                        <div className="content-page">
                            <div className="wrap-login100 m-t-20">
                                <div className="login100-form">
                                    <h3 className="legend last docTitle">15GH Documents</h3>
                                    <Row className="w-100 dec_form">
                                        <Col md={12}>
                                            <label className="required-field text-bold leftField">Download Form 15G/H Template</label>
                                            <a href="#" onClick={this.handelDownloadTemplate} className="text-blue" style={{ fontSize: "16px" }}>Download Template
                                            </a>
                                        </Col>
                                        <Col md={12} className="m-t-10">
                                            <label className="required-field text-bold leftField">Upload your filled Document 15G/H</label>

                                            <input type="file" name="files" id="file10F" onChange={this.handlefile10F} className="m-t-20" />
                                        </Col>
                                        <Col md={12} className="m-t-20">
                                            <button className="btn btn-primary w-100" onClick={this.handleUpload} >
                                                Submit Declaration
                                            </button>
                                        </Col>
                                    </Row>
                                    <div className="txt1 text-center p-t-20">
                                        <img src={goBack} className="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}